module.exports = __webpack_public_path__ + "static/media/MuliB.077ceb91.ttf";